import React, { useEffect } from 'react';
import { useStripe } from '@stripe/react-stripe-js';
import AuthService from '../../services/api/auth';
import LoadingModal from '../LoadingModal';

const RedirectFlow = ({ clientSecret, history }) => {
    const stripe = useStripe();

    useEffect(() => {
        if (!stripe) {
            // Stripe.js has not yet loaded.
            // Make sure to disable form submission until Stripe.js has loaded.
            return;
        }

        stripe.retrieveSetupIntent(clientSecret).then(function(result) {
            if (result.error) {
                // PaymentIntent client secret was invalid
            } else {
                if (result.setupIntent.status === 'succeeded') {
                    // Show your customer that the payment has succeeded
                    // redirect to next step
                    AuthService.stripeValidatePayment().then(response => {
                        response.next ? history.push(response.next) : history.push('/register/status');
                    });
                } else if (result.setupIntent.status === 'requires_payment_method') {
                    // Authentication failed, prompt the customer to enter another payment method
                    // redirect to payment screen
                    history.push(`/register/payment?error=${result.setupIntent.last_setup_error.message}`);
                }
            }
        });
    }, [clientSecret, history, stripe]);

    return <LoadingModal loading={true} message={'PAYMENT_LOADING_MESSAGE'} />;
};

export default RedirectFlow;
